import React from 'react';
import { RED, CYAN } from '../const';

const SVG = ({ style = {}, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={RED} strokeWidth={8} />
      <rect x="24" y="52" width="9" height="17" fill={CYAN} />
      <rect x="39" y="33" width="9" height="36" fill={CYAN} />
      <rect x="54" y="23" width="9" height="47" fill={CYAN} />
      <rect x="69" y="37" width="9" height="32" fill={CYAN} />
      <line x1="18" y1="18" x2="81" y2="81" stroke={RED} strokeWidth={9} />
    </g>
  </svg>
);

export default SVG;
